module.exports = __webpack_public_path__ + "static/media/Vortex-4WD-RV-5380.11d9d870.png";